<template>
  <div>
    <navbar :links="links" />
    <!-- Link to Plans -->
    <v-layout
      v-if="!$store.getters.userHasContentCreatorBooking"
      justify-end
    >
      <router-link
        :to="{name: 'contentcreatorplans'}"
        class="ml-auto mb-2 subheading"
      >
        {{ $t('contentCreatorGoToPlansPage') }}
      </router-link>
    </v-layout>
    <v-layout
      justify-center
      class="mt-4"
    >
      <v-img
        src="/static/contentcreatorlanding_header.jpg"
        contain
        :style="{
          height: $vuetify.breakpoint.smAndUp ? '440px' : 'initial',
          'max-height': headerImageMaxHeight,
        }"
      />
    </v-layout>
    <v-layout
      column
      align-center
    >
      <p class="headline grey--text text--darken-3 mt-4">
        {{ $t('contentCreatorLandingPageTitle') }}
      </p>
      <ul class="subheading">
        <li class="my-1">
          {{ $t('contentCreatorLandingPageBullet1') }}
        </li>
        <li class="my-1">
          {{ $t('contentCreatorLandingPageBullet2') }}
        </li>
        <li class="my-1">
          {{ $t('contentCreatorLandingPageBullet3') }}
        </li>
        <li class="my-1">
          {{ $t('contentCreatorLandingPageBullet4') }}
        </li>
        <li class="my-1">
          {{ $t('contentCreatorLandingPageBullet5') }}
        </li>
        <li class="my-1">
          {{ $t('contentCreatorLandingPageBullet6') }}
        </li>
      </ul>
    </v-layout>
    <!-- Loading indicator -->
    <v-layout
      v-if="loading"
      justify-center
    >
      <v-progress-circular
        indeterminate
        style="position: fixed; z-index: 5"
        class="mt-5 msr--text"
        :size="50"
      />
    </v-layout>
    <v-slide-y-reverse-transition>
      <v-layout
        v-if="!loading"
        column
        align-center
        class="mt-4"
      >
        <div
          v-if="testHasExpired && !canDoTestBooking"
          class="warning--text mb-1"
        >
          {{ testHasExpiredSinceDays }}
        </div>
        <v-btn
          color="msr"
          large
          round
          class="link-btn"
          dark
          :to="{
            name: 'contentcreatorplans',
            query: {
              [nextStepIsTestrun ? 'plan' : '']: nextStepIsTestrun
                ? PRO_PLAN_ID
                : null,
            },
          }"
        >
          <span v-if="testHasExpired && !canDoTestBooking">
            {{ $t('contentCreatorPlanBookNow') }}
          </span>
          <span v-else-if="nextStepIsTestrun">
            {{ $t('contentCreatorCurrentPlanFreeDefaultUpgradeNow') }}
          </span>
          <span v-else>
            {{ $t('contentCreatorGoToPlansPage') }}
          </span>
        </v-btn>
      </v-layout>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar';

export default {
  components: {
    Navbar,
  },
  data() {
    return {
      links: ['dashboard', 'contentcreatorlanding'],
      loading: false,

      PRO_PLAN_ID: 2,
    };
  },
  computed: {
    nextStepIsTestrun() {
      if (!this.$store.getters.userHasContentCreatorBooking) {
        return true;
      }
      return this.testHasExpired && this.canDoTestBooking;
    },
    canDoTestBooking() {
      return this.$store.state.common.contentcreatorCanDoTestBooking;
    },
    /**
     * Make image smaller when there isn't much height available.
     */
    headerImageMaxHeight() {
      if (this.$vuetify.breakpoint.height >= 880) {
        return '440px';
      }
      return '50vh';
    },
    testHasExpired() {
      return (
        this.$store.getters.userHasContentCreatorBooking &&
        this.$userprofile.content_creator_plan_booking.is_test &&
        this.$userprofile.content_creator_plan_booking.test_has_expired
      );
    },
    testHasExpiredSinceDays() {
      if (!this.testHasExpired) {
        return '';
      }
      const numDays = Math.abs(
        this.$userprofile.content_creator_plan_booking.test_expires_in_days
      );
      if (numDays === 1) {
        return this.$t('contentCreatorPlanTestExpiredSinceDaysSingular');
      }

      const template = this.$t('contentCreatorPlanTestExpiredSinceDays');
      return template.replace('{{ days }}', numDays);
    },
  },
  created() {
    this.fetchCanDoTestBooking();
  },
  methods: {
    fetchCanDoTestBooking() {
      this.loading = true;
      this.$store
        .dispatch('RETRIEVE_CONTENTCREATOR_CAN_DO_TEST_BOOKING')
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.link-btn {
  max-width: 100%;
}
.link-btn >>> .v-btn__content {
  white-space: normal;
  flex: 1;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/ContentCreatorLanding.vue